<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-programacion />
    <Ampliacion />
    <VerParametro />
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Parámetros programación
      vacaciones
    </h3>
    <v-card>
      <v-card-text>
        <crud-table
          class="tabla-comprimida-light"
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
                color="primary"
                dark
                @click.native.stop="crearActualizarProgramacion({})"
                slot="activator"
                ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
              >
              <span>Agregar Programacion</span>
            </v-tooltip>
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <td class="text-xs-center">{{ items.item.gestion }}</td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_inicio).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_fin).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_corte).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">{{ items.item.porcentaje }}%</td>
            <td class="text-xs-center">{{ items.item.dias_reserva }}</td>
            <td class="text-xs-center">
              {{ getNombreEstado(items.item.id_estado) }}
            </td>
            <td class="nowrap">
              <v-tooltip bottom>
                <v-btn
                  v-if="
                    items.item.id_estado == 59 &&
                      items.item.id == id_ultimo_registro
                  "
                  icon
                  slot="activator"
                  color="primary"
                  @click.native="crearActualizarProgramacion(items.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <!--   v-if="items.item.id_estado==59 && items.item.id == id_ultimo_registro" -->
              <v-tooltip bottom>
                <v-btn
                  v-if="
                    items.item.id_estado == 59 &&
                      items.item.id == id_ultimo_registro
                  "
                  icon
                  slot="activator"
                  color="error"
                  @click.native="borrar(items.item.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
              <!--     v-if="items.item.id == id_ultimo_registro && bandera_fecha_corte==items.item.gestion && bandera_fecha_actual==items.item.gestion"-->
              <v-tooltip bottom>
                <v-btn
                v-if="
                    items.item.id_estado == 59 &&
                      items.item.id == id_ultimo_registro
                  "
                  icon
                  slot="activator"
                  dark
                  color="indigo"
                  @click.native="aprobarFechaCorte(items.item)"
                >
                  <v-icon>check</v-icon>
                </v-btn>
                <span>Aprobar fecha de corte</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  v-if="
                    items.item.id_estado == 59 &&
                      items.item.id == id_ultimo_registro
                  "
                  icon
                  slot="activator"
                  color="green"
                  dark
                  @click.native="aprobar(items.item.id)"
                >
                  <v-icon>check</v-icon>
                </v-btn>
                <span>Aprobar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  v-if="
                    items.item.id_estado == 62 || items.item.id_estado == 61
                  "
                  icon
                  slot="activator"
                  color="warning"
                  @click.native="ampliacion(items.item)"
                >
                  <v-icon>replay</v-icon>
                </v-btn>
                <span>Ampliar</span>
              </v-tooltip>
              <v-btn
                color="info"
                @click.prevent="verParametro(items.item)"
                icon
                title="Ver información de los parametros"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarProgramacion from "./dialogs/CrearActualizarProgramacion"; // Componente de creación y actualización
import Ampliacion from "./dialogs/Ampliacion"; // Componente de creación y actualización
import VerParametro from "./dialogs/VerParametro"; // Componente de creación y actualización

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    return {
      url: "programacions",
      graphql: true,
      lista_estados: [],
      bandera_fecha_corte: null,
      id_ultimo_registro: null,
      bandera_fecha_actual: false,
      // Cabecera de la tabla
      headers: [
        { text: "Gestión", value: "gestion", align: "center" },
        {
          text: "Fecha inicio programación",
          value: "fecha_inicio",
          align: "center"
        },
        { text: "Fecha fin programación", value: "fecha_fin", align: "center" },
        {
          text: "Fecha corte programación",
          value: "fecha_corte",
          align: "center"
        },
        {
          text: "Porcentaje programación",
          value: "porcentaje",
          align: "center"
        },
        {
          text: "Días de reserva",
          value: "dias_reserva",
          align: "center"
        },
        { text: "Estado", value: "id_estado", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        gestion
        porcentaje
        fecha_corte
        fecha_inicio
        fecha_fin
        fecha_ampliacion
        id_estado
        dias_reserva
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: []
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.listaEstados();
    await this.obtenerUltimoRegistro();
    this.validarGestionActual();
    this.$bus.$on("closeDialogVerParametro", async () => {});

    this.$bus.$on("closeDialog", async () => {
      this.updateList();
      await this.obtenerUltimoRegistro();
      this.validarGestionActual();
    });
  },
  // Métodos y funciones del componente
  methods: {
    //
    validarGestionActual() {
      //this.$moment(new Date()).format("YYYY-MM-DD");
      this.bandera_fecha_actual = this.$moment(new Date()).format("DD/MM/YYYY");
    },
    //
    crearActualizarProgramacion(item) {
      this.$bus.$emit("openDialogCrearActualizarProgramacion", item);
    },
    ampliacion(item) {
      this.$bus.$emit("openDialogAmpliacion", item);
    },
    verParametro(item) {
      this.$bus.$emit("openDialogVerParametro", item);
    },

    async obtenerUltimoRegistro() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
				      query{
                	runQuery(consulta:"select vacaciones.fn_ultimo_registro()"){
                    	respuesta
                      }
                    }
			      	`
        });
        respuesta = respuesta.runQuery.respuesta[0].fn_ultimo_registro.split(
          "|"
        );
        this.id_ultimo_registro = parseInt(respuesta[0]);
        this.bandera_fecha_corte = parseInt(respuesta[1]);
        //id = parseInt(respuesta[0]);
        //return id;
      } catch (error) {
        console.log(error);
      }
    },
    async listaEstados() {
      try {
        let res = await this.$service.graphql({
          query: `
           query{
              estados(tipo:"parametro_vacac"){
                rows{
                  id
                  descripcion

                }
              }
       }
          `
        });

        this.lista_estados = res.estados.rows;
      } catch (error) {
        console.log(error);
      }
    },
    getNombreEstado(id) {
      const found = this.lista_estados.find(
        element => element.id == parseInt(id)
      );
      if (found) {
        return found.descripcion;
      } else {
        return "";
      }
    },
    async borrar(id) {
      this.$confirm("¿Esta seguro de eliminar el registro?", async () => {
        try {
          await this.$service.graphql({
            query: `
								mutation edit($id: ID!, $programacion: EditProgramacion!){
									programacionEdit(id: $id, programacion: $programacion){
										id
									}
								}
							`,
            variables: {
              id: parseInt(id),
              programacion: { id_estado: 60 }
            }
          });
          this.$message.success("Operación realizada correctamente");
          this.updateList();
        } catch (error) {
          console.log(error);
        }
      });
    },
    async aprobarFechaCorte(item) {
      this.$confirm(
        "¿Esta seguro de aprobar la fecha de corte?. Todas las vacaciones pendientes quedaran en estado anulado",
        async () => {
          try {
            let user = this.$storage.get("user");
            let respuesta = await this.$service.graphql({
              query: `
                    query{
                        runQuery(consulta:"SELECT vacaciones.fn_cierra_gestion_vacaciones_programadas(${parseInt(
                          item.gestion
                        ) - 1}, ${user.id})"){
                            respuesta
                            }
                          }
                    `
            });
            respuesta = respuesta.runQuery.respuesta[0].fn_cierra_gestion_vacaciones_programadas.split(
              "|"
            );
            if (respuesta[0] == "1") {
              this.$message.success(
                "La fecha de corte fué aprobada exitosamente y todos los registros de vacaciones de la gestion fuerón anulados"
              );
            }
            this.updateList();
            await this.listaEstados();
            await this.obtenerUltimoRegistro();
            this.validarGestionActual();
          } catch (error) {
            console.log(error);
          }
        }
      );
    },
    async aprobar(id) {
      this.$confirm(
        "¿Esta seguro de aprobar los parametros de esta gestión?",
        async () => {
          try {
            await this.$service
              .graphql({
                query: `
								mutation edit($id: ID!, $programacion: EditProgramacion!){
									programacionEdit(id: $id, programacion: $programacion){
										id
									}
								}
							`,
                variables: {
                  id: parseInt(id),
                  programacion: { id_estado: 62 }
                }
              })
              .then(async response => {
                if (response) {
                  let respuesta = await this.$service.graphql({
                    query: `
                    query{
                        runQuery(consulta:"select vacaciones.fn_crea_estado_vacacion_por_persona(${parseInt(
                          id
                        )})"){
                            respuesta
                            }
                          }
                    `
                  });
                  respuesta =  
                    respuesta.runQuery.respuesta[0]
                      .fn_crea_estado_vacacion_por_persona;
                      respuesta=respuesta.split("|")
                  if (respuesta[0] == "1") {
                    this.$message.success("Operación realizada correctamente");
                    this.updateList();
                    await this.listaEstados();
    await this.obtenerUltimoRegistro();
    this.validarGestionActual();
                  } else {
                    this.$message.error("Ocurrio un error");
                  }
                }
              });
          } catch (error) {
            console.log(error);
          }
        }
      );
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarProgramacion,
    Ampliacion,
    VerParametro
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/parametros_vacacion/Index.vue